import React, { useContext, useEffect, useState, useRef } from "react";
import { Context } from "../../../Context";
import { TeamNegotiationView } from "../../views";
import {
  LocalStorageService,
  WorkflowService
} from "../../../services";
import { useTranslation } from "react-i18next";
import { DialogSystemGLPure } from "../../pures";
import "moment/locale/es";
import { useParams } from 'react-router-dom'

const TeamNegotiationAction = (props) => {
  let autoCompleteCollab = useRef(new Array())
  let autoCompleteGuests = useRef(new Array())

  const [userType, setUserType] = useState({})
  const [teamAssigned, setTeamAssigned] = useState()
  const [selectedItem, setSelectedItem] = useState({})
  const [guestsInputs, setGuestsInputs] = useState([])
  const [message, setMessage] = useState('')
  const [guestWithoutContractor, setGuestWithoutContractor] = useState([])

  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)

  const url = process.env.REACT_APP_MIFIRMA_API;
  const localStorageService = new LocalStorageService();
  const workflowService = new WorkflowService(url);
  const token = localStorageService.getLocalStorageItem("token").idToken
  let { contractWorkflowId: workflowExecutionId } = useParams()

  // Function's Component
  const getTeamAssigned = async (loading = true, updatingState) => {
    if (loading) setLoading(true)
    let teamAssigned = await workflowService.getTeamNegotiation(workflowExecutionId, token)

    // If the team doesnt exists will create it
    if (!teamAssigned.ownTeam) {
      await workflowService.generateTemporalTeamNegotiation(workflowExecutionId, token)
      teamAssigned = await workflowService.getTeamNegotiation(workflowExecutionId, token)
    }

    teamAssigned.ownTeam.possibleCollaborators.map((item) => {
      item.isAssigned = false
      return item
    })

    if (teamAssigned.contractorsWithGuests.find(item => item.id === 0)) {
      teamAssigned.contractorsWithGuests.find(item => item.id === 0).possibleGuests.map((item) => {
        item.isAssigned = false
      })
    } else {
      teamAssigned.contractorsWithGuests.map((item) => {
        item.isAssigned = false
      })

    }
    setTeamAssigned(teamAssigned)


    if (teamAssigned.contractorsWithGuests.length === 0 && guestWithoutContractor.length === 0) {
      props.setNumTeamMembers(-1);
    } else {
      props.setNumTeamMembers(teamAssigned.contractorsWithGuests.length);
    }
    setLoading(false)
    if (updatingState) await successfulModal()
  }

  useEffect(() => {
    if (guestWithoutContractor.length) props.setNumTeamMembers(0)
  }, [guestWithoutContractor])


  const deleteTeamMember = async (member) => {
    try {
      setLoading(true)
      let response = await workflowService.deleteMemberFromWorkflowExecution(workflowExecutionId, member.user.id, member.workflowExecutionMemberTypeId, member.id, token)

      if (response.statusCode === -1) throw new Error(response.message)
      setSelectedItem({})

      await getTeamAssigned(true, true)
    } catch (e) {
      handleMessageError(e.message)
    }
  }

  const validateOnlyThreeMember = (contractorId = null) => {
    if (teamAssigned.contractorsWithGuests && contractorId >= 0) {
      if (teamAssigned.contractorsWithGuests.length !== 0) {
        teamAssigned.contractorsWithGuests.map((contractor, key) => {
          if (contractor.contractorId === contractorId) {
            if (teamAssigned.contractorsWithGuests[key].guests) {
              if (teamAssigned.contractorsWithGuests[key].guests.length >= 3) throw Error('No puede agregar más de 3 personas al equipo de trabajo')
            }
          }
        })
      }
    }
  }

  const addTeamMember = async (usersInvited, type, contractorId) => {
    setLoading(true)
    if (!teamAssigned.contractorsWithGuests.find(item => item.id === 0)) {
      if (type === "guest") {
        for (let i = 0; i < usersInvited.length; i++) {
          if (usersInvited[i].emailContractor.length !== 0) {
            let emailRegex =
              /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;
            if (usersInvited[i].emailContractor.match(emailRegex)) {
              try {
                if (type === 'guest') {
                  validateOnlyThreeMember(contractorId)
                  props.setErrorMissingMembers(false);
                }

                let response = await workflowService.addMemberToTeam(workflowExecutionId, usersInvited[i].emailContractor, type, contractorId, token)

                if (response.statusCode === -1) throw new Error(response.message)
              } catch (e) {
                handleMessageError(e.message)
              }
            } else {
              handleMessageError("Ingrese correos válidos")
            }
          }
        }
      } else {
        for (let i = 0; i < usersInvited.length; i++) {
          if (usersInvited[i].email.length !== 0) {
            let emailRegex =
              /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;
            if (usersInvited[i].email.match(emailRegex)) {
              try {
                let response = await workflowService.addMemberToTeam(workflowExecutionId, usersInvited[i].email, type, contractorId, token)

                if (response.statusCode === -1) throw new Error(response.message)
              } catch (e) {
                handleMessageError(e.message)
              }
            } else {
              handleMessageError("Ingrese correos válidos")
            }
          }
        }
      }
    } else {
      for (let i = 0; i < usersInvited.length; i++) {
        if (usersInvited[i].email.length !== 0) {
          let emailRegex =
            /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;
          if (usersInvited[i].email.match(emailRegex)) {
            try {
              if (type === 'guest') {
                validateOnlyThreeMember(contractorId)
                props.setErrorMissingMembers(false);
              }

              let response = await workflowService.addMemberToTeam(workflowExecutionId, usersInvited[i].email, type, contractorId, token)

              if (response.statusCode === -1) throw new Error(response.message)
            } catch (e) {
              handleMessageError(e.message)
            }
          } else {
            handleMessageError("Ingrese correos válidos")
          }
        }
      }
    }
    await getTeamAssigned(true, true)
  }

  const createMember = async (email, type, contractorId) => {
    setLoading(true)
    if (email.length !== 0) {
      let emailRegex =
        /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;
      if (email.match(emailRegex)) {
        try {
          if (type === 'guest') {
            validateOnlyThreeMember(contractorId)
            props.setErrorMissingMembers(false);
          }

          let response = await workflowService.addMemberToTeam(workflowExecutionId, email, type, contractorId, token)

          if (response.statusCode === -1) throw new Error(response.message)

          // setGuestsInputs([])

        } catch (e) {
          handleMessageError(e.message)
        }
      } else {
        handleMessageError("Ingrese un correo valido")
      }
    }
    await getTeamAssigned(true, true)
  }

  const successfulModal = async () => {
    setLoading(false)
    setSuccess(true)

    setTimeout(() => {
      setSuccess(false)
    }, 2000)
  }

  const handleMessageError = (message) => {
    setMessage(message)
    setLoading(false)
    setError(true)

    setTimeout(() => {
      setError(false)
    }, 4000)
  }

  const handleChangeGuestInput = (key, ev) => {
    let array = []
    array[key] = ev.target.value

    setGuestsInputs(array);
  };

  // Functions to actions
  useEffect(() => {
    // If user exists to delete...
    if (selectedItem) {
      if (selectedItem.user) {
        deleteTeamMember(selectedItem)
        setSelectedItem({})
      }
    }
  }, [selectedItem])


  // First time execution
  useEffect(() => {
    getTeamAssigned()
  }, [])

  return (
    <>
      <TeamNegotiationView
        teamAssigned={teamAssigned}
        userType={userType}
        setError={setError}
        setMessage={setMessage}
        onInvitedRedirectRegister={() => { }}
        setSelectedItem={setSelectedItem}
        guestsInputs={guestsInputs}
        handleChangeGuestInput={handleChangeGuestInput}
        addTeamMember={addTeamMember}
        createMember={createMember}
        guestWithoutContractor={guestWithoutContractor}
        setGuestWithoutContractor={setGuestWithoutContractor}
        autoCompleteCollab={autoCompleteCollab}
        autoCompleteGuests={autoCompleteGuests}
        errorMissingMembers={props.errorMissingMembers}
      />
      <DialogSystemGLPure
        showLoadingRequesting={loading}
        showCompletedRequesting={success}
        showErrorRequesting={error}
        toggleErrorRequesting={() => { setError(false) }}
        toggleLoadingRequesting={() => { setLoading(false) }}
        message={message}
      />
    </>
  )
}

function TeamNegotiationActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <TeamNegotiationAction {...props} t={t} setShowError={setShowError} />
  );
}

export { TeamNegotiationActionContainer as default }